<template>
  <div class="app-container">
    <div class="toolbar">
      <el-select
        v-model="filters.status"
        clearable
        placeholder="Status"
        size="small"
        @change="loadTasks"
      >
        <el-option v-for="status in statuses" :key="status" :label="status" :value="status" />
      </el-select>
      <el-button size="small" type="primary" @click="loadTasks">Refresh</el-button>
    </div>

    <el-table :data="tasks" border>
      <el-table-column prop="id" label="Task" width="80" />
      <el-table-column prop="styleCode" label="Style Code" width="140" />
      <el-table-column prop="expectedProductName" label="Product" min-width="220" />
      <el-table-column prop="customerSizeSystem" label="Size System" width="120" />
      <el-table-column prop="customerSize" label="Customer Size" width="120" />
      <el-table-column prop="dewuDisplaySize" label="Lookup Size" width="120" />
      <el-table-column prop="status" label="Status" width="180" />
      <el-table-column label="Action" width="300">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" @click="openResult(row)">Manual Result</el-button>
          <el-button size="mini" type="success" @click="generateQuote(row)"
            >Generate Quote</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="Manual Lookup Result" :visible.sync="dialogVisible" width="560px">
      <el-form label-width="150px">
        <el-form-item label="Status">
          <el-select v-model="result.status">
            <el-option
              v-for="status in resultStatuses"
              :key="status"
              :label="status"
              :value="status"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Available">
          <el-switch v-model="result.available" />
        </el-form-item>
        <el-form-item label="Visible CNY Price">
          <el-input-number v-model="result.visibleCnyPrice" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="Matched Style Code">
          <el-input v-model="result.matchedStyleCode" />
        </el-form-item>
        <el-form-item label="Matched Size">
          <el-input v-model="result.matchedSize" />
        </el-form-item>
        <el-form-item label="Evidence">
          <el-input v-model="result.evidence" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitResult">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statuses: [
        "PENDING",
        "ASSIGNED",
        "DEVICE_PROCESSING",
        "COMPLETED",
        "PRODUCT_NOT_FOUND",
        "PRODUCT_MATCH_UNCERTAIN",
        "SIZE_NOT_FOUND",
        "SIZE_UNAVAILABLE",
        "LOGIN_REQUIRED",
        "SMS_REQUIRED",
        "CAPTCHA_REQUIRED",
        "UI_CHANGED",
        "DEVICE_OFFLINE",
        "MANUAL_REVIEW_REQUIRED",
        "FAILED",
        "EXPIRED",
      ],
      resultStatuses: [
        "COMPLETED",
        "PRODUCT_NOT_FOUND",
        "PRODUCT_MATCH_UNCERTAIN",
        "SIZE_NOT_FOUND",
        "SIZE_UNAVAILABLE",
        "LOGIN_REQUIRED",
        "SMS_REQUIRED",
        "CAPTCHA_REQUIRED",
        "UI_CHANGED",
        "MANUAL_REVIEW_REQUIRED",
        "FAILED",
      ],
      filters: { status: "" },
      tasks: [],
      selectedTask: null,
      dialogVisible: false,
      result: {},
    };
  },
  created() {
    this.loadTasks();
  },
  methods: {
    async loadTasks() {
      const params = {};
      if (this.filters.status) params.status = this.filters.status;
      const data = await this.axios.get("mall:/api/admin/sourcing/lookup-tasks", { params });
      this.tasks = data.content || data.items || [];
    },
    openResult(row) {
      this.selectedTask = row;
      this.result = {
        status: "COMPLETED",
        available: true,
        visibleCnyPrice: 0,
        matchedStyleCode: row.styleCode,
        matchedSize: row.dewuDisplaySize,
        evidence: "",
      };
      this.dialogVisible = true;
    },
    async submitResult() {
      await this.axios.post(
        `mall:/api/admin/sourcing/lookup-tasks/${this.selectedTask.id}/manual-result`,
        this.result
      );
      this.dialogVisible = false;
      this.$message.success("Lookup result saved and quote generation queued");
      await this.loadTasks();
    },
    async generateQuote(row) {
      try {
        await this.axios.post(`mall:/api/admin/sourcing/lookup-tasks/${row.id}/quote`, {
          pricingInput: {},
        });
        this.$message.success("Quote generated");
      } catch (e) {
        this.$message.error(this.errorMessage(e));
      }
    },
    errorMessage(error) {
      return (
        (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        "Quote could not be generated"
      );
    },
  },
};
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
</style>
